import Vue from 'vue';
import App from './App.vue';
import router from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './assets/styles/global.css';

Vue.config.productionTip = false;

// Initialize AOS
// AOS.init({
//   duration: 800,
//   once: true,
//   offset: 100,
// });

new Vue({
  router,
  render: (h) => h(App),
  mounted() {
    // 触发预渲染快照抓取
    document.dispatchEvent(new Event('app-rendered'))
  },
}).$mount('#app');